import React from 'react';
import PropTypes from 'prop-types';

export class FieldInput extends React.Component {
  renderInner() {
    const {
      type,
      name,
      value,
      placeholder,
      required,
      readOnly,
      onChange
    } = this.props;

    if (readOnly) {
      return value;
    } else {
      return <input className='input'
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        required={required}
        onChange={onChange} />;
    }
  }

  render() {
    return <div className='field'>
      <label className='label'>{this.props.label}</label>
      <p className='control has-icons-left has-icons-right'>
        {this.renderInner()}
      </p>
    </div>;
  }
}

FieldInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/common/components/FieldInput.jsx